import { Chart } from '@frontend/chart/types';

export const VENDING_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'transaction_completed', data: [{ label: 'full_period', value: 842 }] },
        { name: 'transaction_completed_with_failures', data: [{ label: 'full_period', value: 31 }] },
        { name: 'transaction_failed', data: [{ label: 'full_period', value: 18 }] },
        { name: 'transaction_created', data: [{ label: 'full_period', value: 12 }] },
        { name: 'transaction_cancelled', data: [{ label: 'full_period', value: 9 }] }
    ]
};
